module.exports = __webpack_public_path__ + "static/img/DSC_2590.1ff503b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2590.jpg
// module id = 265
// module chunks = 0